import styled from 'styled-components';
import { breakpoint } from '../theme/breakpoint';

export const StyledGraph = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.standard};

  text {
    font-size: ${({ theme }) => theme.fontsize.base};
  }

  svg .domain {
    display: none;
  }

  .tick {
    line {
      stroke: ${({ theme }) => theme.palette.borderLight};
      opacity: 0.2;
    }
  }

  .key {
    margin-bottom: ${({ theme }) => theme.spacing.standard};
    display: grid;
    grid-template-columns: 100%;
    .key-list {
      display: flex;
      align-items: center;

      svg {
        margin-right: ${({ theme }) => theme.spacing.standard};
      }
    }

    ${breakpoint.tablet`
      grid-template-columns: 50% 50%;
    `}
  }
`;
